.chart {
  width: 100%;
  height: 400px;
  margin-bottom: 2em;
  padding: 0;
}

.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2em;
}

.variableNameLabel {
  font-size: 9px;
  text-transform: uppercase;
}

.legendContainer {
  margin-bottom: 1em;

  p {
    margin-bottom: 0;
  }
}

.legend {
  margin-bottom: 1em;

  & .legendOwn,
  & .legendGroup {
    padding-left: 15px;
    margin-right: 1em;

    &::before {
      content: "";
      width: 10px;
      height: 10px;
      border-radius: 5px;
      position: absolute;
      margin-left: -15px;
      margin-top: 5px;
    }
  }

  & .legendOwn::before {
    background-color: var(--orange);
  }

  & .legendGroup::before {
    background-color: var(--blue);
  }
}

.figureDescription {
  height: 0;
  overflow: hidden;
}
